import { useLayoutEffect, useState } from "react";

/**
 * Хук для получения размера окна браузера
 */
export const useWindowSize = () => {
  const [size, setSize] = useState<Array<number>>([
    window.innerHeight,
    window.innerWidth,
  ]);

  useLayoutEffect(() => {
    const updateSize = () => setSize([window.innerHeight, window.innerWidth]);
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  return size;
};
